import React from 'react';

import { useDeviceDetails } from '@apis/asset-data-service/queries/use-device-details';
import type { DefinitionProps } from '@packages/components/definition/definition';
import { Definition } from '@packages/components/definition/definition';

interface AssetInformationFieldWrapperProps
  extends Omit<DefinitionProps, 'isLoading'> {
  assetId: string;
}

export const AssetInformationFieldWrapper = ({
  assetId,
  children,
  ...rest
}: AssetInformationFieldWrapperProps) => {
  const { isPending } = useDeviceDetails(assetId);

  return (
    <Definition isLoading={isPending} {...rest}>
      {children}
    </Definition>
  );
};
